






























import Media from '@/types/Media.interface'
import Vue from 'vue'
import MessageMediaMenu from '@/components/MessageMediaMenu.vue'
export default Vue.extend({
    components: { MessageMediaMenu },
    props: {
        image: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: 'Select new image'
        }
    },
    methods: {
        changeImage(file: Media) {
            //  Grab the link from our media
            const link = file.link

            //  Tell the parent to update the image with this link
            this.$emit('change', link)
        }
    }
})
